import React from "react";
import ReactDOM from "react-dom/client";
import {BrowserRouter} from "react-router-dom";
import {Router} from "./router/Router";
import Header from "./pages/partial/Header";
import {Box} from "@mui/material";
import {ThemeProvider} from "@mui/material";
import {theme} from "./stylesheets/theme";

const root = ReactDOM.createRoot(document.getElementById("root"));
export const Index = React.memo(() => {
  const [lgFontFg, setLgFontFg] = React.useState(Boolean(parseInt(sessionStorage.getItem("lgFontFg"))));
  return (
    <BrowserRouter>
      <ThemeProvider
        theme = {theme(lgFontFg)}
      >
        <Box
          display = "flex"
          flexDirection = "column"
          sx = {{minHeight: "100%"}}
        >
          <Header
            lgFontFg = {lgFontFg}
            setLgFontFg = {setLgFontFg}
          />
          <Router />
        </Box>
      </ThemeProvider>
    </BrowserRouter>
  );
});

root.render(
  <Index />
);